export default [
    { key: 'sales', label: 'Sales', component: 'SalesTable' },
    { key: 'quotes', label: 'Quotes', component: 'QuotesTable' },
    { key: 'inventory', label: 'Inventory', component: 'InventoryTable' },
    { key: 'vendor', label: 'Vendor', component: 'VendorTable' },
    { key: 'ils', label: 'ILS', component: 'ILSTable' },
    { key: 'marketplace_parts', label: 'Marketplace Parts', component: 'MarketplacePartsTable' },
    { key: 'google_search', label: 'Google Search', component: 'GoogleSearchTable' },
    { key: 'parts', label: 'Parts (Various Sources)', component: 'PartsVariousSourcesTable' },
    { key: 'substitutes', label: 'Substitutes', component: 'SubstitutesTable' },
    { key: 'stats', label: 'Stats', component: 'StatsTable' },
]
